import React from "react";
import { IconProps } from "./IconProps";

const Plus: React.FC<IconProps> = ({
    size = 20,
    color = "#F7F9F9",
    ...props
}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 21 21"
            fill="none"
            {...props}
        >
            <path
                d="M10.0233 4.20166L10.0457 15.8683M4.20117 10.0462L15.8678 10.0238"
                stroke={color}
                strokeWidth="1.66667"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default Plus;
